/* global __COMMIT_SHA__ */

import Rollbar from 'rollbar';
import config from 'config';

const defaultConfig = {
    captureUncaught: true,
    captureUnhandledRejections: false,
    enabled: false,
    payload: {
        client: {
            javascript: {
                source_map_enabled: true,
                code_version: __COMMIT_SHA__
            }
        }
    }
};

const mergedConfig = {
    ...defaultConfig,
    ...config.ROLLBAR
};

let instance;

if (mergedConfig.enabled) {
    instance = new Rollbar(mergedConfig);
    window.addEventListener('unhandledrejection', (event) => {
        let reason = event.reason;
        let promise = event.promise;
        let detail = event.detail;

        if (!reason && detail) {
            reason = detail.reason;
            promise = detail.promise;
        }

        let requestConfig = reason.config;
        if (requestConfig) {
            let response = reason.response;
            instance.error('unhandled response error', {
                url: requestConfig.url,
                data: response ? response.data : undefined,
                status: response ? response.status : undefined
            });
        } else {
            instance.handleUnhandledRejection(reason, promise);
        }
    });
}

export default {
    error: (...args) => instance ? instance.error(...args) : null   
};


// WEBPACK FOOTER //
// ./src/rollbar.js